import {
    ITEM_DETAIL_REQUEST,
    GET_EXPENDITURE,
    SET_EXPENDITURE,
    SET_ORDER_DETAIL,
    SET_REQUEST_OPTION,
    SET_APPROVAL_ORDER_REQUEST,
    SUBMIT_ORDER_APPROVAL_REQUEST,
    SET_IS_ORDER_APPROVAL_COMPLETE,
    SET_GRID_COLUMNS,
    SET_ORDERS_STATUS,
    GET_ORDERS_STATUS,
    GET_FLEET_PROCESSING_GRID_DATA,
    SET_FLEET_PROCESSING_GRID_DATA,
    SET_IS_ORDER_CANCELED,
    CANCEL_ORDER_REQUEST,
    GET_ACTION_POPUP_VALUE,
    GET_PENDING_ORDERS_GRID_DATA,
    SET_PENDING_ORDERS_GRID_DATA,
    GET_GRID_ORDERS_COUNT,
    SET_GRID_ORDERS_COUNT,
    GET_MY_ORDERS_GRID_DATA,
    SET_MY_ORDERS_GRID_DATA,
    SET_ALL_PENDING_ORDERS_GRID_DATA,
    GET_ALL_PENDING_ORDERS_GRID_DATA,
    IS_GRID_DATA_LOADING,
    IS_GRID_COUNTS_LOADING
} from './types'

export const setItemDetailRequest = (selectedRequest: any) => {
    return {
        type: ITEM_DETAIL_REQUEST,
        selectedRequest
    }
}

export const getExpenditure = (expenditure: any) => {
    return {
        type: GET_EXPENDITURE,
        expenditure
    }
}

export const setExpenditure = (expenditure: any) => {
    return {
        type: SET_EXPENDITURE,
        expenditure
    }
}

export const setOrderDetail = (value: any) => {
    return {
        type: SET_ORDER_DETAIL,
        value
    }
}

export const setRequestOption = (value: any) => {
    return {
        type: SET_REQUEST_OPTION,
        value
    }
}

export const setApprovalOrderRequest = (approvalOrderRequest: any) => {
    return {
        type: SET_APPROVAL_ORDER_REQUEST,
        approvalOrderRequest
    }
}

export const setIsOrderApprovalComplete = (isOrderApprovalComplete: any) => {
    return {
        type: SET_IS_ORDER_APPROVAL_COMPLETE,
        isOrderApprovalComplete
    }
}

export const submitOrderApprovalRequest = (submitOrderRequest: any) => {
    return {
        type: SUBMIT_ORDER_APPROVAL_REQUEST,
        submitOrderRequest
    }
}

export const getGridOrdersCount = (userId: any) => {
    return {
        type: GET_GRID_ORDERS_COUNT,
        userId
    }
}

export const setGridOrdersCount = (count: any) => {
    return {
        type: SET_GRID_ORDERS_COUNT,
        count
    }
}

export const getPendingOrdersGridData = (request: any) => {
    return {
        type: GET_PENDING_ORDERS_GRID_DATA,
        request
    }
}

export const setPendingOrdersGridData = (gridData: any) => {
    return {
        type: SET_PENDING_ORDERS_GRID_DATA,
        gridData
    }
}

export const getMyOrdersGridData = (request: any) => {
    return {
        type: GET_MY_ORDERS_GRID_DATA,
        request
    }
}

export const setMyOrdersGridData = (gridData: any) => {
    return {
        type: SET_MY_ORDERS_GRID_DATA,
        gridData
    }
}

export const getFleetProcessingGridData = (request:any) => {
    return {
        type: GET_FLEET_PROCESSING_GRID_DATA,
        request
    }
}

export const setFleetProcessingGridData = (fleetProcessingGridData:any) => {
    return {
        type: SET_FLEET_PROCESSING_GRID_DATA,
        fleetProcessingGridData
    }
}

export const setGridColumns = (gridColumns: any) => {
    return {
        type: SET_GRID_COLUMNS,
        gridColumns
    }
}
export const setOrdersStatus = (ordersStatus: any) => {
    return {
        type: SET_ORDERS_STATUS,
        ordersStatus
    }
}

export const getOrdersStatus = () => {
    return {
        type: GET_ORDERS_STATUS
    }
}

export const cancelOrderReq = (cancelOrderRequest: any) => {
    return {
        type: CANCEL_ORDER_REQUEST,
        cancelOrderRequest
    }
}

export const setIsOrderCanceled = (isOrderCanceled: any) => {
    return {
        type: SET_IS_ORDER_CANCELED,
        isOrderCanceled
    }
}
export const getActionPopupValue = (data:any) => {
    return {
        type: GET_ACTION_POPUP_VALUE,
        payload: data
    }
}

export const getAllPendingOrdersGridData = (request: any) => {
    return {
        type: GET_ALL_PENDING_ORDERS_GRID_DATA,
        request
    }
}

export const setAllPendingOrdersGridData = (allPendingGridData: any) => {
    return {
        type: SET_ALL_PENDING_ORDERS_GRID_DATA,
        allPendingGridData
    }
}

export const setIsGridDataLoading = (flag: any) => {
    return {
        type: IS_GRID_DATA_LOADING,
        flag
    }
}
export const setIsGridCountsLoading = (flag: any) => {
    return {
        type: IS_GRID_COUNTS_LOADING,
        flag
    }
}